/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import cx from 'classnames';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import { find } from 'lodash';
import styles from './Navigation.css';
import { STUDENT_VIEW } from '../../redux/app';
import { getLinksForNavbar, getLinksForRightMenu } from './utils';
import NavigationBarLeftContainer from './components/NavigationBarLeftContainer';
import NavigationBarMiddleContainer from './components/NavigationBarMiddleContainer';
import NavigationBarRightContainer from './components/NavigationBarRightContainer';
import NavigationMobileSider from './components/NavigationMobileSider';
import { trackPUAnalytics } from '../../services/Mixpanel';

const Navigation = ({
  me,
  active,
  setActive,
  view,
  customPrograms,
  authLevel,
  companyDomain,
  jobBoard,
  terms,
  // customProgramGeneral,
  showMyJourney,
  siteMode,
  connectMode,
  intake,
  demographicQuestions,
  companyName,
  isMobile,
  isTablet,
  location,
  pgHomeLink,
}) => {
  const [isSiderOpen, setIsSiderOpen] = useState(false);
  const mainNavLinks = getLinksForNavbar({
    authLevel,
    companyDomain,
    connectMode,
    customPrograms,
    intake,
    jobBoard,
    me,
    siteMode,
    view,
    terms,
    showMyJourney,
    setActive,
  });
  const rightMenuLinks = getLinksForRightMenu({
    me,
    view,
    siteMode,
    intake,
    customPrograms,
    authLevel,
    terms,
    showMyJourney,
    demographicQuestions,
  });
  const pathName = location ? location.pathname : null;
  useEffect(() => {
    if (mainNavLinks.length && pathName) {
      mainNavLinks.forEach(({ path, id, childRoutes }) => {
        if (pathName.indexOf(path) > -1) {
          setActive(id);
        } else if (childRoutes) {
          const childRoute = find(childRoutes, route =>
            pathName.includes(route),
          );
          if (childRoute) {
            setActive(id);
          }
        }
      });
    }

    return () => {
      setActive('');
    };
  }, [pathName]);

  return (
    <div
      className={styles.container}
    >
      {isSiderOpen && (isMobile || isTablet) ? (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          className={styles.siderOverlay}
          onClick={() => setIsSiderOpen(false)}
        />
      ) : null}
      <NavigationMobileSider
        isMobile={isMobile}
        isTablet={isTablet}
        isSiderOpen={isSiderOpen}
        active={active}
        setIsSiderOpen={setIsSiderOpen}
        setActive={setActive}
        me={me}
        mainNavLinks={mainNavLinks}
        rightMenuLinks={rightMenuLinks}
        pgHomeLink={pgHomeLink}
      />
      <div className={styles.navigation}>
        <nav aria-label="Primary" className={styles.navbar}>
          <div
            className={cx(styles.navbarLeft, {
              [styles.navbarLeftMobile]: isMobile || isTablet,
            })}
          >
            <NavigationBarLeftContainer
              companyName={companyName}
              isMobile={isMobile}
              isTablet={isTablet}
              setIsSiderOpen={setIsSiderOpen}
            />
            {!isMobile && !isTablet ? (
              <NavigationBarMiddleContainer
                active={active}
                setActive={setActive}
                isMobile={isMobile}
                links={mainNavLinks}
                pgHomeLink={pgHomeLink}
              />
            ) : null}
          </div>
          <div
            className={cx(styles.navbarRight, {
              [styles.navbarRightMobile]: isMobile || isTablet,
            })}
          >
            <NavigationBarRightContainer
              me={me}
              isMobile={isMobile}
              isTablet={isTablet}
              links={rightMenuLinks}
            />
          </div>
        </nav>
      </div>
    </div>
  );
};

Navigation.propTypes = {
  me: PropTypes.object,
  authLevel: PropTypes.number,
  active: PropTypes.string,
  setActive: PropTypes.func,
  customPrograms: PropTypes.bool,
  view: PropTypes.string,
  jobBoard: PropTypes.bool,
  showMyJourney: PropTypes.bool,
  companyDomain: PropTypes.string,
  terms: PropTypes.string,
  siteMode: PropTypes.number,
  // customProgramGeneral: PropTypes.bool,
  connectMode: PropTypes.bool,
  intake: PropTypes.bool,
  demographicQuestions: PropTypes.bool,
  companyName: PropTypes.string,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  pgHomeLink: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.oneOf([null])],
  ),
};

const logoutLink = renderComponent(() => (
  <div className={styles.container}>
    <Link
      onClick={() => trackPUAnalytics('PathwayU:LogOut', { pageLocation: window.location.href })}
      to="/logout"
    >LOG OUT</Link>
  </div>
));

export default compose(
  withRouter,
  connect(({ me, auth, app, theme, lock, intake, pgHomeLink }) => ({
    me,
    authLevel: Number(auth.level),
    view: app.view,
    jobBoard: theme.jobBoard,
    customPrograms: theme.customPrograms,
    customProgramGeneral: theme.customProgramGeneral,
    terms: theme.terms,
    companyDomain: theme.companyDomain,
    siteMode: theme.siteMode, // hide tools for candidates
    showMyJourney: theme.showMyJourney,
    connectMode: theme.connectMode,
    lock: lock && app.view === STUDENT_VIEW,
    intake:
            (theme.purposeSurvey && !intake.assessments.purpose) ||
            (theme.demographicQuestions && !intake.assessments.demographic),
    demographicQuestions: theme.demographicQuestions,
    color: theme.primaryColor,
    pgHomeLink,
  })),
  withState('active', 'setActive', ''),
  branch(({ me }) => !me, renderNothing),
  branch(
    ({ lock, companyDomain }) => lock && companyDomain !== 'petersons',
    logoutLink,
  ),
)(Navigation);



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/Navigation.js